import styles from './Symbol.module.scss';

export const SymbolSize30 = () => {
  return (
    <svg
      className={styles.root}
      width="30"
      height="30"
      data-testid="ZapierLogoSymbolSmall"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="30" height="30" rx="5" fill="#FF4F00" />
    </svg>
  );
};
